export default {
    state: {
        sessionToken: {},
        requestRealmId: {},
    },

    getters: {
        sessionToken(state)
        {
            return state.sessionToken;
        },
        requestRealmId(state)
        {
            return state.requestRealmId;
        },
    },
    mutations: {
        setSessionToken(state, value)
        {
            state.sessionToken = value;
        },
        setRequestRealmId(state, value)
        {
            state.requestRealmId = value;
        },
    },

    actions: {
        setSessionToken(context, token)
        {
            context.commit('setSessionToken', token);
        },
        setRequestRealmId(context, requestRealmId)
        {
            context.commit('setRequestRealmId', requestRealmId);
        },
    },
};
